import DefaultColumnFilters from '@entity/EntityTable/ColumnFilters';

// We can import additional Components here to expand or overwrite Boilerplate Components
const ColumnFilters = Object.assign(DefaultColumnFilters, {});

export default ColumnFilters;
